import styled from "styled-components";

export const Card = styled.div`
  background-color: #f9f9f9;
  border-radius: 10px;
  padding: 1rem 0.7rem;
  width: 15%;
  min-width: 200px; /* prevent too small cards */
  flex: 1;
  box-shadow: 3px 3px 10px rgba(40, 40, 40, 0.1);
  text-align: center;
  direction: rtl;

  @media (max-width: 1200px) {
    width: 22%;
  }
  @media (max-width: 992px) {
    width: 45%;
  }
  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1.3rem;
  margin-top: 0;
  color: rgb(10, 92, 86);

  @media (max-width: 600px) {
    font-size: 1.2rem;
  }
`;

export const SupTitle = styled.p`
  font-size: 13px;
  font-weight: bold;
  padding-bottom: 2px;
`;

export const ValueBox = styled.input`
  padding: 0.75rem;
  background-color: #eee;
  border: 2px solid ${({ $loading }) => ($loading ? "#f9a825" : "#ccc")};
  text-align: center;
  font-weight: bold;
  width: 60%;
  margin: 0 auto;

  &:focus {
    outline: none;
    border-color: #0a5c56;
  }

  @media (max-width: 600px) {
    width: 80%;
  }
`;

export const Flex = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 0.7rem;
  margin-bottom: 1rem;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
`;